import { render, staticRenderFns } from "./SelectLightCourseMaterial.vue?vue&type=template&id=25e0e8c1&"
import script from "./SelectLightCourseMaterial.vue?vue&type=script&lang=js&"
export * from "./SelectLightCourseMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports